import { render } from "./LocationList.vue?vue&type=template&id=64f3e9e9&ts=true"
import script from "./LocationList.vue?vue&type=script&lang=ts"
export * from "./LocationList.vue?vue&type=script&lang=ts"

import "./LocationList.vue?vue&type=style&index=0&id=64f3e9e9&lang=css"

import exportComponent from "/Users/matthias/Code/uniki/vergabe/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__